import {Button} from "../../../atoms/Button";
import {TextArea} from "../../../atoms/Textarea";
import {useForm} from "react-hook-form";

interface IInputDiv {
    onSubmit: (text: string) => void;
}

export default function InputDiv({onSubmit}: IInputDiv) {
    const {register, watch,
      handleSubmit, formState: {errors}, reset} = useForm<{
        comment: string }>()

    const submit = (data: { comment: string }) => {
        reset();
        onSubmit(data.comment);
    }

    const comment = watch('comment') || ""

  return (
        <form onSubmit={handleSubmit(submit)}>
            <div className="flex flex-col items-end gap-md">
                <TextArea
                    placeholder="Escreva um comentário"
                    rows={5}
                    {...register('comment')}
                    errorMessage={errors.comment && "Digite um comentário"}
                />
                <Button size="regular" disabled={comment.length <= 3}>
                    Postar comentário
                </Button>
            </div>
        </form>
    )
}
